import { Injectable, NgZone } from "@angular/core";
import { Router } from "@angular/router";
import { UserService } from "./user.service";

@Injectable({
  providedIn: "root",
})
export class IdleTimeoutService {
  private timeout: any;
  private idleTime: number = 80400000; // 15 minutes in milliseconds (15 * 60 * 1000)
  private inactivityWarningTime: number = 60000; // 1 minute before log out warning (optional)

  constructor(
    private router: Router,
    private ngZone: NgZone,
    public _userService: UserService
  ) {
    // Automatically reset the timeout when user is active
    this.resetIdleTimeout();

    // Add event listeners for user activity
    this.setupIdleTimeoutListeners();
  }

  // Set up event listeners for activity detection
  private setupIdleTimeoutListeners() {
    // Reset the timer on mouse movement, keyboard press, or clicks
    window.addEventListener("mousemove", this.resetIdleTimeout.bind(this));
    window.addEventListener("keypress", this.resetIdleTimeout.bind(this));
    window.addEventListener("click", this.resetIdleTimeout.bind(this));
    window.addEventListener("scroll", this.resetIdleTimeout.bind(this));
  }

  // Reset the idle timer and start the countdown again
  private resetIdleTimeout() {
    this.clearTimeout(); // Clear any existing timeout

    // Set a new timeout to log out after inactivity
    this.ngZone.run(() => {
      // Show warning after 14 minutes (1 minute before logout)
      setTimeout(() => {
        this.logout();
        // alert("You will be logged out in 1 minute due to inactivity");
        let userConfirmed = window.confirm(
          "You will be logged out in 1 minute due to inactivity"
        );
        if (userConfirmed) {
          console.log("User clicked OK");
          this.logout();
        } else {
          this.logout();
        }
      }, this.idleTime - this.inactivityWarningTime); // Trigger warning 1 minute before logout

      this.timeout = setTimeout(() => {
        this.logout();
      }, this.idleTime);
    });
  }

  // Clear the timeout if the user becomes active again
  private clearTimeout() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  // Handle user logout when timeout is reached
  private logout() {
    // Clear session storage and local storage
    window.sessionStorage.clear();
    window.localStorage.clear();
    this._userService.allClearStorage();
    // Optionally, you can redirect to a login page or show a timeout message
    this.router.navigate(["/login"]); // Redirect to login page
  }
}
